let _accessToken = null;
let _logoutCallback = null;

export function setGlobalAccessToken(token) {
  _accessToken = token;
}

export function getGlobalAccessToken() {
  return _accessToken;
}

export function setGlobalLogoutCallback(callback) {
  _logoutCallback = callback;
}

export function globalLogout() {
  if (_logoutCallback) {
    _logoutCallback();
  }
}

// The refresh endpoint reads a different cookie per subdomain:
//   dashboard.rasedbank.com -> Admin    (adminRefreshToken cookie)
//   rasedbank.com           -> Employee (refreshToken cookie)
// Default to Employee for local dev / any other host.
export function getActorType() {
  const host =
    typeof window !== "undefined" ? window.location.hostname : "";
  return host.startsWith("dashboard.") ? "Admin" : "Employee";
}